module.exports = __webpack_public_path__ + "img/SODB.9fb22149.png";